import { FormErrors } from 'redux-form';
import { FolderParams } from '@Builder/myFolder/edit/validate';

const validate = (values: FolderParams): FormErrors<FolderParams> => {
  const errors: FormErrors<FolderParams> = {};

  if (!values.name) {
    errors.name = 'folder.form.name.error';
  }

  return errors;
};
export default validate;
